// UserSearch.ts
import { HttpParams }   from '@angular/common/http';


export default class UserSearch {
    id                  : Number  = null;
    username            : String  = null;
    probe               : String  = null;
    auth_id             : Number  = null;
    authorities         : Number[] = null;
    with_fk             : Boolean = false;
    with_permissions    : Boolean = false;

    no_superuser        : Boolean = false;             
    no_anonymous        : Boolean = false;

    constructor(dict = null)
    {
      if (dict !== null)
      {
        this.id                     = dict["id"]                || null;
        this.username               = dict["username"]          || null;
        this.probe                  = dict["probe"]             || null;
        this.with_fk                = dict["with_fk"]           || false;
        this.with_permissions       = dict["with_permissions"]  || false;
        this.auth_id                = dict["auth_id"]           || null;

        this.no_superuser           = dict["no_superuser"]      || null;
        this.no_anonymous           = dict["no_anonymous"]      || null;
      }
    }

    getHttpParams()
    {
      var params = new HttpParams({});
      if (this.id                 !== null) { params = params.set('id', this.id.toString()); }
      if (this.probe              !== null) { params = params.set('probe', this.probe.toString() ); }
      if (this.auth_id            !== null) { params = params.set('auth_id', this.auth_id.toString() ); }
      if (this.authorities        !== null) { params = params.set('authorities', JSON.stringify(this.authorities).toString() ); }
      if (this.with_fk            !== null) { params = params.set('with_fk', this.with_fk.toString() ); }
      if (this.with_permissions   !== null) { params = params.set('with_permissions', this.with_permissions.toString() ); }
      if (this.no_superuser       !== null) { params = params.set('nosuper', this.no_superuser.toString() ); }
      if (this.no_anonymous       !== null) { params = params.set('noanony', this.no_anonymous.toString() ); }
      
      return params;
    }

  }